import React from 'react';

export const HomePage = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="panel panel-default">
            <div className="panel-heading">Page not implemented</div>
            <div className="panel-body">This page was not implemented yet.</div>
          </div>
        </div>
      </div>
    </div>
  );
};
